import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { FaWhatsapp } from "react-icons/fa";
import LogoDark from "../../assets/img/logo-dark.png";

const SplashScreen = ({ visible }) => (
  <div
    className="fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-700 ease-out"
    style={{
      opacity: visible ? 1 : 0,
      pointerEvents: visible ? "auto" : "none",
      background: "linear-gradient(160deg, #FAF8F5 0%, #F3EDE5 50%, #F8F5F0 100%)",
    }}
  >
    {/* Logo con fade-in y scale */}
    <div
      style={{
        animation: "splashLogoIn 1s ease-out forwards",
      }}
    >
      <img
        src={LogoDark}
        alt="Estancia La Alameda"
        className="w-[200px]"
      />
    </div>

    {/* Línea dorada expandible */}
    <div className="mt-6 mb-5 overflow-hidden" style={{ width: "120px", height: "1px" }}>
      <div
        style={{
          height: "1px",
          background: "linear-gradient(90deg, transparent, #a37d4c, transparent)",
          animation: "splashLine 1.2s ease-out 0.4s forwards",
          transform: "scaleX(0)",
        }}
      />
    </div>

    {/* Tagline */}
    <p
      className="font-tertiary uppercase tracking-[5px] text-[11px]"
      style={{
        color: "#a37d4c",
        animation: "splashFadeUp 0.8s ease-out 0.6s forwards",
        opacity: 0,
      }}
    >
      Hotel Boutique
    </p>

    {/* Spinner elegante — arco dorado girando */}
    <div
      className="mt-10"
      style={{
        animation: "splashFadeUp 0.6s ease-out 0.8s forwards",
        opacity: 0,
      }}
    >
      <div
        style={{
          width: "28px",
          height: "28px",
          border: "1.5px solid rgba(163, 125, 76, 0.12)",
          borderTopColor: "#a37d4c",
          borderRadius: "50%",
          animation: "splashSpin 1.2s linear infinite",
        }}
      />
    </div>

    <style>{`
      @keyframes splashLogoIn {
        0% { opacity: 0; transform: scale(0.92); }
        100% { opacity: 1; transform: scale(1); }
      }
      @keyframes splashLine {
        0% { transform: scaleX(0); }
        100% { transform: scaleX(1); }
      }
      @keyframes splashFadeUp {
        0% { opacity: 0; transform: translateY(6px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      @keyframes splashSpin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const isSplashDone = () => sessionStorage.getItem("splashDone") === "1";

const Layout = () => {
  const [showSplash, setShowSplash] = useState(() => !isSplashDone());
  const [splashVisible, setSplashVisible] = useState(() => !isSplashDone());

  useEffect(() => {
    if (!showSplash) return;

    const handleReady = () => {
      sessionStorage.setItem("splashDone", "1");
      setSplashVisible(false);
      setTimeout(() => setShowSplash(false), 700);
    };

    if (document.readyState === "complete") {
      setTimeout(handleReady, 800);
    } else {
      const onLoad = () => setTimeout(handleReady, 400);
      window.addEventListener("load", onLoad);
      return () => window.removeEventListener("load", onLoad);
    }
  }, [showSplash]);

  return (
    <div className="flex flex-col min-h-screen">
      {showSplash && <SplashScreen visible={splashVisible} />}
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      {/* Botón de WhatsApp */}
      <a
        href="https://api.whatsapp.com/send?phone=5491157133534&text=Hola%20Alameda,%20quisiera%20realizar%20una%20consulta"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-fab fixed bottom-5 right-5 bg-accent text-white p-3 rounded-full shadow-lg hover:bg-accent-hover transition-all duration-300 z-50"
        aria-label="Enviar mensaje a través de WhatsApp"
      >
        <FaWhatsapp className="h-10 w-10" />
      </a>
    </div>
  );
};

export default Layout;
